import { GET, POST, PUT } from './api';

const table = 'contato-clientes';

// Canais adicionais do titular (telefone/e-mail) descobertos pelo operador.
// Nao existe Delete: o endpoint retorna 403 porque apagar deixaria as
// tentativas com historico orfao. Para remover, use Desativar.
export const Create = async (params) => {
  return await POST(`/${table}`, params, true);
};

export const Read = async (filters = '') => {
  return await GET(`/${table}${filters}`, true);
};

export const ReadOne = async (id) => {
  return await GET(`/${table}/${id}?populate=*`, true);
};

export const Update = async (params, id) => {
  return await PUT(`/${table}/${id}`, params, true);
};

export const ReadByCliente = async (id, filters = '') => {
  return await GET(`/${table}?filters[cliente][id][$eq]=${id}${filters}`, true);
};

export const Desativar = async (id) => {
  return await PUT(`/${table}/${id}`, { data: { ativo: false } }, true);
};

// Marcar principal desmarca o anterior do mesmo tipo e espelha o numero no
// cadastro do cliente (telefone_celular / telefone_fixo / telefone_empresa).
export const MarcarPrincipal = async (id) => {
  return await PUT(`/${table}/${id}`, { data: { principal: true } }, true);
};
